import React from 'react';

import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import { Link as LinkComponent } from 'wanderu-components';
import {
    selectCurrency,
    selectLocale,
} from 'wanderu-i18n';
import {
    buildAbsoluteUrl,
} from 'wanderu-utils';

const EXTERNAL_LINK_MARKER = /^(\/\/)|(:\/\/)/;

function A(props) {
    const {
        children,
        className = '',
        // eslint-disable-next-line react/prop-types, @typescript-eslint/no-unused-vars
        dispatch: _dispatch,
        href,
        locale,
        currency,
        reduxCurrency = null,
        mergeQueries = true,
        native = false,
        prependLocale = true, // Should be removed when ui3 dies
        queries = {},
        component,
        componentProps,
        // withRouter injected props
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        location,
        // eslint-disable-next-line no-unused-vars, react/prop-types, @typescript-eslint/no-unused-vars
        staticContext,
        // eslint-disable-next-line no-unused-vars, react/prop-types, @typescript-eslint/no-unused-vars
        match,
        history,
        ...otherProps
    } = props;

    function parseQueryString(query) {
        if (typeof query === 'object') {
            return query;
        }

        return queryString.parse(query);
    }

    // need to use _history.location because location does not get updated
    const oldQueries = parseQueryString(history.location.search);
    let newQueries = parseQueryString(queries);

    if (currency !== reduxCurrency) {
        newQueries = {
            ...newQueries,
            cur: currency,
        };
    }

    if (mergeQueries) {
        newQueries = {
            cur: oldQueries.cur,
            ...newQueries,
        };
    }

    const removeLocale = href === '/' && locale === 'en-us';

    const url = buildAbsoluteUrl({
        href,
        language: removeLocale || !prependLocale
            ? undefined
            : locale,
        queries: newQueries,
    });

    if (native || href.match(EXTERNAL_LINK_MARKER)) {
        return (
            <LinkComponent
                className={className}
                component={component}
                componentProps={{
                    componentProps: {
                        ...componentProps,
                        component: component
                            ? 'a'
                            : undefined,
                    },
                }}
                href={url}
                {...otherProps}
            >
                {children}
            </LinkComponent>
        );
    }

    return (
        <LinkComponent
            className={className}
            component={component || Link}
            componentProps={{
                componentProps: {
                    ...componentProps,
                    component: component
                        ? Link
                        : undefined,
                },
            }}
            to={url}
            {...otherProps}
        >
            {children}
        </LinkComponent>
    );
}

A.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    currency: PropTypes.string.isRequired,
    history: PropTypes.object,
    href: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    location: PropTypes.object,
    mergeQueries: PropTypes.bool,
    native: PropTypes.bool,
    onClick: PropTypes.func,
    prependLocale: PropTypes.bool,
    queries: PropTypes.object,
    reduxCurrency: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
    return {
        currency: ownProps.currency || selectCurrency(state),
        locale: ownProps.locale || selectLocale(state),
        reduxCurrency: selectCurrency(state),
    };
}

export {
    A,
    mapStateToProps,
};
const ConnectedA = connect(mapStateToProps)(A);
export default withRouter(ConnectedA);
